module.exports = __webpack_public_path__ + "static/media/Icon_menu_reservation.ced1ff7b.svg";